import { render, staticRenderFns } from "./StaffActivatorOverview.vue?vue&type=template&id=050cbd41&scoped=true&"
import script from "./StaffActivatorOverview.vue?vue&type=script&lang=js&"
export * from "./StaffActivatorOverview.vue?vue&type=script&lang=js&"
import style0 from "./StaffActivatorOverview.vue?vue&type=style&index=0&id=050cbd41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050cbd41",
  null
  
)

export default component.exports